import React from 'react';

import { LocalPopup } from 'js/components/common/Popup';
import { Layout } from 'js/components/system/Page/components/Layout';

import { dispatcher } from 'dispatcher';
import { clsx } from 'js/app/utils/clsx.util';
import { useCurrentItemMenu } from 'js/app/hooks/menu/useMenu';
import { getRootClassNames } from 'js/components/system/Page/helpers';
import { MENU_CLASSES } from '@interlayer/js/app/components/main/DefaultMenu/constants';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import style from './PagePopup.scss';

export const PagePopup = ({ page, isLoading }) => {
    const { isShowAsModal = false } = page;
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const { popupWidth, popupWidthUnit, hidePopUpTitle, name, rootClassNames } = page;

    const currentItem = useCurrentItemMenu(page.path);
    const withLogo = currentItem && !currentItem.cssClasses.includes(MENU_CLASSES.NO_LOGO_MODAL);
    const isWhiteBg = currentItem && currentItem.cssClasses.includes(MENU_CLASSES.WHITE_POPUP_BG);

    const handlerOnClose = () => {
        dispatcher.dispatch('pageInPopup:close');
        navigateToPopupBackgroundPage();
    };

    return (
        <LocalPopup
            isModal={isShowAsModal}
            onClose={handlerOnClose}
            title={hidePopUpTitle ? undefined : name}
            style={{ width: popupWidth !== 0 && `${popupWidth}${popupWidthUnit}` }}
            fullscreen
            isPageInPopup
            className={clsx(style.container, getRootClassNames(rootClassNames).join(' '), { [style.isWhiteBg]: isWhiteBg })}
            withLogo={withLogo}
            isUsePortal={false}
        >
            <Layout page={page} isLoading={isLoading} isPageInPopup />
        </LocalPopup>
    );
};
